import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faHome, faArrowLeft } from '@fortawesome/free-solid-svg-icons';

const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 70vh;
  padding: 20px;
  text-align: center;
`;

const ErrorIcon = styled.div`
  font-size: 80px;
  color: var(--primary-light);
  margin-bottom: 20px;
  
  @media (max-width: 768px) {
    font-size: 60px;
  }
`;

const ErrorCode = styled.h1`
  font-size: 120px;
  font-weight: 800;
  margin: 0;
  background: linear-gradient(to right, var(--primary-light), #90cdf4);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  line-height: 1;
  
  @media (max-width: 768px) {
    font-size: 80px;
  }
`;

const ErrorTitle = styled.h2`
  font-size: 32px;
  margin-bottom: 15px;
  
  @media (max-width: 768px) {
    font-size: 24px;
  }
`;

const ErrorMessage = styled.p`
  font-size: 18px;
  color: var(--text-dim);
  max-width: 600px;
  margin-bottom: 30px;
  
  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 15px;
  
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const ErrorPage = ({ code = "404", title = "Page Not Found", message = "The page you are looking for has not been added or has been moved." }) => {
  const navigate = useNavigate();
  
  return (
    <ErrorContainer>
      <ErrorIcon>
        <FontAwesomeIcon icon={faExclamationTriangle} />
      </ErrorIcon>
      <ErrorCode>{code}</ErrorCode>
      <ErrorTitle>{title}</ErrorTitle>
      <ErrorMessage>{message}</ErrorMessage>
      <ButtonGroup>
        <button className="btn btn-primary" onClick={() => navigate('/')}>
          <FontAwesomeIcon icon={faHome} /> Go Home
        </button>
        <button className="btn btn-secondary" onClick={() => navigate(-1)}>
          <FontAwesomeIcon icon={faArrowLeft} /> Go Back
        </button>
      </ButtonGroup>
    </ErrorContainer>
  );
};

export default ErrorPage;
